export default {
  addItem: {
    margin: 10,
  },
  addItemContainer: {
    textAlign: 'right',
  },
  body: {
    padding: 10,
  },
  iconCol: {
    width: 80,
  },
  actionCol: {
    width: 80,
  },
};



// WEBPACK FOOTER //
// ./src/components/Printer/styles.js